export const DEFAULT_VISIBLE_METHODS_ON_INIT = 5
